
export class Company {    
    idCompany = 0;
    businessName = '';
    category = '';
    ruc = '';
    eMail = '';
    address = '';
    phone = '';
    iPress = '';
    ugiPress = '';
    countryId = '';
    locationId = 0;
    district_id = 0;
    userAdmin = 0;
}